import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { singleScanRequest } from "../../redux/actions/singleScanActions";
import "../../styles/InputSheet.css";
import { MdOpenInNew } from "react-icons/md";
import Pagination from "../../helper/Pagination";
import SingleScanOffcanvas from "../../helper/SingleScanOffcanvas";
import { FaSearch } from "react-icons/fa";

const SingleScanList = () => {
  const dispatch = useDispatch();
  const { loading, scans, error } = useSelector(
    (state) =>
      state.singleScan || {
        loading: false,
        scans: [],
        error: null,
      },
  );
  const [search, setSearch] = useState("");
  const [userTypeFilter, setUserTypeFilter] = useState("");
  const [selectedScan, setSelectedScan] = useState(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("user") || "{}");
    const oemId = userData.oemPartner?.id;
    if (oemId) {
      dispatch(singleScanRequest(oemId, search, userTypeFilter));
    }
  }, [dispatch, search, userTypeFilter]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handleViewDetails = (scan) => {
    setSelectedScan(scan);
    setShowOffcanvas(true);
  };

  const handleDownloadReport = (domainLink) => {
    window.open(domainLink, "_blank");
  };

  return (
    <div className="page-container">
      <div className="page-card scroll-container">
        <div
          className="mt-2 d-flex align-items-end justify-content-end"
          style={{ padding: "0 20px" }}
        >
          {/* Filters */}
          <div className="d-flex align-items-center gap-2">
            <select
              className="form-input me-3"
              style={{ width: "150px" }}
              value={userTypeFilter}
              onChange={(e) => setUserTypeFilter(e.target.value)}
            >
              <option value="">All User Types</option>
              <option value="appsumo">AppSumo</option>
              <option value="normal">Normal</option>
            </select>
          </div>
          <div className="position-relative d-flex justify-content-end">
            <input
              type="search"
              placeholder="Search scans...."
              className="form-input"
              value={search}
              onChange={handleSearch}
              style={{ width: "220px" }}
            />
            {search === "" && (
              <div
                className="position-absolute"
                style={{
                  top: "50%",
                  right: "13px",
                  transform: "translateY(-50%)",
                  color: "#666",
                }}
              >
                <FaSearch />
              </div>
            )}
          </div>
        </div>
        <div className="input-form-section">
          <div className="table-scroll-wrapper">
            <table className="partners-table">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Date/Time</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Domain</th>
                  <th>User Type</th>
                  <th>Report Scan</th>
                  <th>Language</th>
                  <th>Scan Url</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="12"
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#666",
                      }}
                    >
                      <div className="loading-spinner"></div>
                    </td>
                  </tr>
                ) : scans?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="12"
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#666",
                      }}
                    >
                      No scan-list found
                    </td>
                  </tr>
                ) : (
                  scans.map((scan, index) => (
                    <tr key={scan._id}>
                      <td>{index + 1}</td>
                      <td>
                        {new Date(scan.scanCreatedAt).toLocaleDateString()}
                        <br />
                        <small>
                          {new Date(scan.scanCreatedAt).toLocaleTimeString()}
                        </small>
                      </td>
                      <td>
                        {scan.firstName
                          ? scan.firstName.charAt(0).toUpperCase() +
                            scan.firstName.slice(1)
                          : ""}{" "}
                        {scan.lastName
                          ? scan.lastName.charAt(0).toUpperCase() +
                            scan.lastName.slice(1)
                          : ""}
                      </td>
                      <td>{scan.email}</td>
                      <td>{scan.domain}</td>
                      <td>
                        {scan.userType
                          ? scan.userType.charAt(0).toUpperCase() +
                            scan.userType.slice(1)
                          : "-"}
                      </td>
                      <td>
                        <span
                          className={`status-badge ${
                            scan.reportSend ? "sent" : "pending"
                          }`}
                        >
                          {scan.reportSend ? "Sent" : "Pending"}
                        </span>
                      </td>
                      <td>
                        {scan.language === "eng"
                          ? "English"
                          : scan.language === "ja"
                            ? "Japanese"
                            : scan.language}
                      </td>
                      {/* <td>
                        <span
                          className={`status-badge ${
                            scan.verified ? "verified" : "unverified"
                          }`}
                        >
                          {scan.verified ? "Verified" : "Unverified"}
                        </span>
                      </td> */}
                      <td>
                        {scan.reportSend ? (
                          <MdOpenInNew
                            onClick={() =>
                              handleDownloadReport(scan.domainLink)
                            }
                            className="info_pointer fs-5"
                            title="Download Report"
                            style={{ color: "#737EE2", cursor: "pointer" }}
                          />
                        ) : (
                          <span style={{ color: "#666" }}>N/A</span>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <SingleScanOffcanvas
          show={showOffcanvas}
          onHide={() => setShowOffcanvas(false)}
          scanData={selectedScan}
        />
      </div>
    </div>
  );
};

export default SingleScanList;
